import { __rest } from "tslib";
import { bool } from 'prop-types';
import React from 'react';
import { useCollapse } from 'react-collapsed';
export default function Collapse(props) {
    const { isExpanded } = props, otherProps = __rest(props, ["isExpanded"]);
    const collapseObj = useCollapse({ isExpanded });
    const collapseProps = collapseObj.getCollapseProps(Object.assign({}, otherProps));
    return React.createElement("div", Object.assign({}, collapseProps));
}
Collapse.propTypes = {
    isExpanded: bool,
};
//# sourceMappingURL=Collapse.js.map